import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../shadcn-ui/card';
import { Label } from '../shadcn-ui/label';
import { Input } from '../shadcn-ui/input';
import { Minus, Plus } from 'lucide-react';
import { Button } from '../shadcn-ui/button';
import { useFieldArray, useFormContext } from 'react-hook-form';

const EstateGrowerCard = ({ loading }) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  // Growers field array
  const {
    fields: growerFields,
    append: appendGrower,
    remove: removeGrower,
  } = useFieldArray({
    control,
    name: 'growers',
  });

  // Managers field array
  const {
    fields: managerFields,
    append: appendManager,
    remove: removeManager,
  } = useFieldArray({
    control,
    name: 'managers',
  });

  return (
    <Card className="rounded-2xl border border-border shadow-sm">
      <CardHeader className="px-4 pb-3">
        <CardTitle className="text-base font-medium">Grower details</CardTitle>
      </CardHeader>

      <CardContent className="space-y-[22px] p-4 pt-0">
        <div className="space-y-2">
          <Label className="mb-1.5 text-sm font-normal text-[hsl(var(--text-foreground-secondary))]">
            Grower details<span className="">*</span>
          </Label>

          <div className="space-y-3">
            {growerFields.map((field, idx) => (
              <div key={field.id} className="grid w-full grid-cols-[1fr_1fr_max-content_max-content] items-start gap-2">
                <div className="flex-1 rounded-[10px]">
                  <Input
                    disabled={loading}
                    className="bg-white text-sm"
                    placeholder="Grower Name"
                    {...register(`growers.${idx}.name`)}
                  />
                  {errors?.growers?.[idx]?.name && (
                    <div className="mt-1 text-xs text-red-500">{errors.growers?.[idx]?.name?.message}</div>
                  )}
                </div>

                <div className="rounded-[10px]">
                  <Input
                    disabled={loading}
                    className="rounded-[10px] bg-white text-sm"
                    type="tel"
                    placeholder="Number"
                    {...register(`growers.${idx}.phone_number`)}
                  />

                  {errors?.growers?.[idx]?.phone_number && (
                    <div className="mt-1 text-xs text-red-500">{errors.growers?.[idx]?.phone_number?.message}</div>
                  )}
                </div>

                {/* Add / Remove Button */}
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => removeGrower(idx)}
                  disabled={growerFields.length === 1}
                >
                  <Minus className="h-4 w-4" />
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => appendGrower({ name: '', phone_number: '' })}
                >
                  <Plus className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>

        {/* Manager Info */}
        <div className="space-y-2">
          <Label className="mb-1.5 text-sm font-normal text-[hsl(var(--text-foreground-secondary))]">
            Manager details
          </Label>

          <div className="space-y-3">
            {managerFields.map((field, idx) => (
              <div key={field.id} className="grid w-full grid-cols-[1fr_1fr_max-content_max-content] items-start gap-2">
                <div className="flex-1 rounded-[10px]">
                  <Input
                    disabled={loading}
                    className="bg-white text-sm"
                    placeholder="Manager Name"
                    {...register(`managers.${idx}.name`)}
                  />
                  {errors?.managers?.[idx]?.name && (
                    <div className="mt-1 text-xs text-red-500">{errors.managers?.[idx]?.name?.message}</div>
                  )}
                </div>

                <div className="rounded-[10px]">
                  <Input
                    disabled={loading}
                    className="w-full rounded-[10px] bg-white text-sm"
                    type="tel"
                    placeholder="Number"
                    {...register(`managers.${idx}.phone_number`)}
                  />

                  {errors?.managers?.[idx]?.phone_number && (
                    <div className="mt-1 text-xs text-red-500">{errors.managers?.[idx]?.phone_number?.message}</div>
                  )}
                </div>

                {/* Add / Remove Button */}
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => removeManager(idx)}
                  disabled={managerFields.length === 1}
                >
                  <Minus className="h-4 w-4" />
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="mt-1 h-8 w-8 flex-shrink-0 rounded-full"
                  onClick={() => appendManager({ name: '', phone_number: '' })}
                >
                  <Plus className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EstateGrowerCard;
